export const GENSET_BRAND_CONSTANT = {
  GET_BRAND_START: 'LI/POI/brand/get/requested',
  GET_BRAND_FAILED: 'LI/POI/brand/get/failed',
  GET_BRAND_SUCCESS: 'LI/POI/brand/get/success',

  RESET_STATUS: 'LI/POI/brand/reset-status',
  RESET_ALL: 'LI/POI/brand/reset-all',
};
